import axios from 'axios'
import router from '../../router'
const state = {
  answerList: [],
  tranAnswer: ''
}

const getters = {
  getAnswerList (state) {
    return state.answerList
  },
  getTranAnswerData (state) {
    return state.tranAnswer
  }
}

const mutations = {
  setAnswerList (state, payload) {
    state.answerList = payload
  },
  setTranAnswerData (state, payload) {
    state.tranAnswer = payload
  }
}

const actions = {
  apiAnswerList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getQnaAnswerList', payload)
        .then((response) => {
          // console.log(response.data)
          if (response.data.length > 0) {
            context.commit('setAnswerList', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranQnaAnswer (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranQnaAnswerList', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranAnswerData', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/qna.js